import { IListItem } from '../models/interfaces';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faFileArchive, faFile } from '@fortawesome/free-solid-svg-icons';
import { FileListItem } from './FileListItem';
import { useNavigate } from 'react-router-dom';
import { useManualsContext } from '../contexts/ManualsContext';
import { ObservableObject } from '@legendapp/state';
import { observer } from '@legendapp/state/react';

interface IManualsListItemProps {
  manual: ObservableObject<IListItem>;
}
export const ManualsListItem = observer((props: IManualsListItemProps) => {
  const navigate = useNavigate();
  const manualContext = useManualsContext();
  const fileType = props.manual.fileType?.get() || 'pdf';
  const isDownloadableFile = fileType === 'zip' || fileType === 'file';

  const onFavorite = () => {
    manualContext.favoriteManualAsync(props.manual.peek());
  };

  // Get appropriate icon based on file type
  const getIcon = () => {
    if (fileType === 'zip') return faFileArchive;
    if (fileType === 'file') return faFile;
    return faFilePdf;
  };

  const onClick = () => {
    // For downloadable files (zip/file), trigger download
    if (isDownloadableFile) {
      const link = document.createElement('a');
      link.href = props.manual.Url.get();
      link.download = ''; // Browser will use filename from URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    // For PDFs, keep existing behavior
    if (isIOS()) {
      window.open(props.manual.Url.get(), '_blank', 'noopener,noreferrer');
      return;
    }
    navigate(`/manuals/manual/${props.manual.key.get()}`);
  };

  const onShare = () => {
    // For downloadable files, share triggers download
    // For PDFs, open in new tab
    if (isDownloadableFile) {
      onClick(); // Reuse download logic
    } else {
      window.open(props.manual.Url.get(), '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <FileListItem
      icon={getIcon()}
      label={props.manual.label.get()}
      isFavorite={props.manual.IsFavorite.get()}
      onClick={onClick}
      onShare={onShare}
      onFavorite={onFavorite}
    />
  );
});

function isIOS(): boolean {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
}
